import { render, staticRenderFns } from "./SurveysView.vue?vue&type=template&id=75f5066a"
import script from "./SurveysView.vue?vue&type=script&lang=js"
export * from "./SurveysView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports